import { useSelector } from 'react-redux';
import { getReferralIncomes } from '../../selectors';

export const useReferralIncomes = () => ({
  incomes: useSelector(getReferralIncomes),
});
